// Componente que exibe um indicador de carregamento (spinner)
// É utilizado durante operações assíncronas como chamadas de API
import Spinner from "../../../../../components/UI/Spinner";
import StateView from '../shared/StateView';
import classes from '../../RescueCode.module.scss';

/**
 * LoadingView
 * 
 * Componente responsável por exibir o estado de carregamento.
 * É renderizado enquanto as requisições estão sendo processadas 
 * ou quando o sistema está verificando o código de convite.
 * 
 * Utiliza o componente StateView como base e aplica a classe CSS
 * spinnerContainer para centralizar o indicador de carregamento.
 */
const LoadingView = () => {
  return (
    <StateView className={classes.spinnerContainer}>
      <Spinner />
    </StateView>
  );
};

export default LoadingView;